import moment from 'moment';

export const formatDate = (date: string) => {
  const momentObject = moment.utc(date);
  return momentObject.format('M/D/yyyy');
};

export const formatDatetime = (iso8601datetime: string) => {
  const datetimeObject = new Date(iso8601datetime);
  const options = {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
  } as const;
  let output = '';
  const datetimeParts = new Intl.DateTimeFormat('en-US', options).formatToParts(
    datetimeObject
  );
  for (const part of datetimeParts) {
    if (part['type'] === 'literal' && part['value'] === ', ') {
      output = output + ' at ';
    } else {
      output = output + part['value'];
    }
  }
  return output;
};
